<button
  type="button"
  class="web-notifications-bell"
  aria-label="Meldingen"
  (click)="toggleMenu($event)"
>
  <span class="bell-with-badge">
    <fa-icon [icon]="['fal', 'bell']"></fa-icon>
    <ion-badge *ngIf="(count$ | async) as count" color="danger">
      {{ count > 99 ? '99+' : count }}
    </ion-badge>
  </span>
</button>

<ion-popover
  [isOpen]="menuOpen"
  [event]="menuEvent"
  [arrow]="false"
  [dismissOnSelect]="false"
  [showBackdrop]="true"
  side="bottom"
  alignment="end"
  cssClass="web-notifications-popover"
  class="web-notifications-popover"
  (didDismiss)="onMenuDismissed()"
>
  <ng-template>
    <ion-content class="ion-no-padding">
      <ng-container *ngIf="inbox$ | async as inbox">
        <ion-segment
          [value]="activeTab"
          (ionChange)="onTabChange($event)"
          mode="md"
          class="web-notifications-tabs"
        >
          <ion-segment-button value="unhandled">
            <span class="web-notifications-tab-label">
              Openstaand
              <ion-badge *ngIf="inbox.unhandled_count > 0" color="danger">
                {{ inbox.unhandled_count > 99 ? '99+' : inbox.unhandled_count }}
              </ion-badge>
            </span>
          </ion-segment-button>
          <ion-segment-button value="handled">Afgehandeld</ion-segment-button>
        </ion-segment>

        <ion-list lines="full" *ngIf="activeTab === 'unhandled'">
          <ion-item *ngFor="let notification of inbox.unhandled">
            <ng-container
              [ngTemplateOutlet]="notificationItem"
              [ngTemplateOutletContext]="{ notification: notification, handled: false }"
            ></ng-container>
          </ion-item>
          <ion-item *ngIf="inbox.unhandled.length === 0" lines="none">
            <ion-label color="medium">Geen openstaande meldingen</ion-label>
          </ion-item>
          <ion-item
            *ngIf="inbox.unhandled_count > inbox.unhandled.length"
            lines="none"
          >
            <ion-label color="medium">
              Nog {{ inbox.unhandled_count - inbox.unhandled.length }} oudere meldingen
            </ion-label>
          </ion-item>
        </ion-list>

        <ion-list lines="full" *ngIf="activeTab === 'handled'">
          <ion-item *ngFor="let notification of inbox.handled">
            <ng-container
              [ngTemplateOutlet]="notificationItem"
              [ngTemplateOutletContext]="{ notification: notification, handled: true }"
            ></ng-container>
          </ion-item>
          <ion-item *ngIf="inbox.handled.length === 0" lines="none">
            <ion-label color="medium">Nog geen afgehandelde meldingen</ion-label>
          </ion-item>
        </ion-list>
      </ng-container>
    </ion-content>
  </ng-template>
</ion-popover>

<ng-template #notificationItem let-notification="notification" let-handled="handled">
  <div class="web-notifications-item">
    <button
      *ngIf="notification.link"
      type="button"
      class="web-notifications-open"
      title="Openen"
      aria-label="Openen"
      (click)="open(notification); $event.stopPropagation()"
    >
      <fa-icon [icon]="['fal', 'external-link']"></fa-icon>
    </button>
    <ion-label class="ion-text-wrap">
      <h2>{{ notification.title }}</h2>
      <p class="web-notifications-date">
        {{ notification.created_at | date : 'dd-MM-yyyy HH:mm' }}
      </p>
      <div
        class="web-notifications-content"
        *ngIf="notification.content"
        [innerHTML]="notification.content"
      ></div>
      <button
        *ngIf="!handled"
        type="button"
        class="web-notifications-handle"
        (click)="handle(notification, $event)"
      >
        Afhandelen
      </button>
    </ion-label>
  </div>
</ng-template>
